import { render, staticRenderFns } from "./tag-list.vue?vue&type=template&id=c278ae70&scoped=true"
import script from "./tag-list.vue?vue&type=script&lang=js"
export * from "./tag-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c278ae70",
  null
  
)

export default component.exports